var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.45037 2.10044C6.16982 0.961312 7.83105 0.961311 8.5505 2.10044L12.9218 9.02174C13.6929 10.2425 12.8156 11.8341 11.3718 11.8341H2.62909C1.18524 11.8341 0.308019 10.2425 1.07903 9.02174L5.45037 2.10044ZM7.83366 5.00065C7.83366 4.54041 7.46056 4.16732 7.00033 4.16732C6.54009 4.16732 6.16699 4.54041 6.16699 5.00065V8.00065C6.16699 8.32381 6.35094 8.60401 6.61984 8.74225C6.25627 8.89195 6.00033 9.24974 6.00033 9.66732C6.00033 10.2196 6.44804 10.6673 7.00033 10.6673C7.55261 10.6673 8.00033 10.2196 8.00033 9.66732C8.00033 9.24974 7.74438 8.89195 7.38081 8.74225C7.64971 8.60401 7.83366 8.32381 7.83366 8.00065V5.00065Z",
    fill: "url(#paint0_linear_10316_32456)",
    stroke: "url(#paint1_linear_10316_32456)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10316_32456",
    x1: 20.4173,
    y1: 6.54008,
    x2: 8.95269,
    y2: -6.73402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F05F5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10316_32456",
    x1: 20.4173,
    y1: 6.54008,
    x2: 8.95269,
    y2: -6.73402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F05F5F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.cc5cb5237c73e602f76f111e8421ebf3.svg";
export { ForwardRef as ReactComponent };